import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import moment from "moment";
import { labelStyles } from "views/pages/manage/masters/studentFinancials/chargeModifications/constants";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"
import { hardcodeDropdown } from "../common/services";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { INTERNAL_REFUND } from "./constants"
const FilterForm = ({
    closePopup,
    dropdownData,
    filterForm,
    setFilterForm,
    filterCount,
    setFilterCount,
    applyFilterHandler,
    filterFormHandler,
    buTypeChangeHandler,
    buLoading
}) => {

    const resetFilterForm = () => {
        setFilterCount(0);
        setFilterForm({});
        applyFilterHandler();
        closePopup();
    };

    const { branchType, businessArea, businessAreas, terms, paymentMode } = dropdownData;
    const [disabled, setDisabled] = useState(true);
    const [cashierItems, setCashierItems] = useState([]);
    const [isCashierLoading, setIsCashierLoading] = useState(false);
    const isAdvanceBranchType = filterForm?.branchType?.[0]?.label?.toLowerCase() == "advance" ? true : false;

    const handleApplyFilter = () => {
        let fCount = getFilterCount({ ...filterForm }, ["searchByValue"]);
        setFilterCount(fCount);
        applyFilterHandler(0, filterForm);
        closePopup();
    };

    useEffect(() => {
        const branchTypeLabel = filterForm?.branchType?.[0]?.label?.toLowerCase();

        if (!filterForm?.businessArea?.length) {
            setDisabled(true);
            filterFormHandler("cashierOffice", null);
            return;
        }

        if (branchTypeLabel === "advance") {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [filterForm.businessArea, filterForm.branchType]);

    useEffect(() => {
        const fetchCashiers = async () => {
            try {
                setIsCashierLoading(true);
                const data = await fetchAllPromisedData(endpoint?.businessArea?.getCashierOfficeDetails);
                if (Array.isArray(data)) {
                    const transformed = data.map((item) => ({
                        label: item?.businessAreaDispValue,
                        value: item?.businessAreaDispValue,
                        raw: item,
                    }));
                    setCashierItems(transformed)
                } else {
                    console.log("Invalid response format for cashier office list.");
                }
            } catch (e) {
                console.log(e);
            }
            finally {
                setIsCashierLoading(false);
            }
        }
        fetchCashiers();
    }, []);

    const handleCashierChange = (val) => {
        filterFormHandler("cashierOffice", val);
    }

    const BRANCH_TYPES = ["franchise", "owned", "subcontractor"];

    const businessareaHandler = (val) => {
        filterFormHandler("businessArea", Array.isArray(val) ? val : val ? [val] : []);

        if (BRANCH_TYPES.includes(filterForm?.branchType?.[0]?.label?.toLowerCase())) {
            setDisabled(true);
            handleCashierChange(val);
        } else {
            //advance case
            filterFormHandler("businessArea", val ? [val] : [])
            setDisabled(false);
        }
    };

    return (
        <Card
            className="mb-0 regular-body label-color"
            style={{ width: "330px", borderRadius: "12px" }}
        >
            <CardBody className="d-flex flex-column">
                <div className="mb-1 d-flex align-items-start justify-content-between">
                    <div className="regular-large-bold">Filters</div>
                </div>

                <div className="d-flex flex-column gap-md">

                    <AAutoComplete
                        label="Branch Type"
                        currentValue={filterForm?.branchType}
                        items={branchType}
                        handleChange={buTypeChangeHandler}
                        isMulti={false}
                    />

                    <AAutoComplete
                        label="Branch"
                        currentValue={
                            isAdvanceBranchType
                                ? filterForm?.businessArea?.[0] || null
                                : filterForm?.businessArea || []
                        }
                        items={businessAreas}
                        handleChange={(value) => {
                            businessareaHandler(value);
                        }}
                        selectAllMenuButton={true}
                        isMulti={!isAdvanceBranchType}
                        isShowCount={!isAdvanceBranchType}
                        isLoading={buLoading}
                    />

                    <AAutoComplete
                        label="Cashier office"
                        items={cashierItems}
                        handleChange={handleCashierChange}
                        currentValue={filterForm?.cashierOffice}
                        isMulti={true}
                        isShowCount={true}
                        isDisabled={disabled}
                        loading={isCashierLoading}
                    />

                    <AAutoComplete
                        label="Term"
                        currentValue={filterForm?.terms}
                        items={terms}
                        handleChange={(value) => {
                            filterFormHandler("terms", value);
                        }}
                        selectAllMenuButton={true}
                        isShowCount={true}
                        isMulti={true}
                    />

                    <AAutoComplete
                        label="Refund Status"
                        currentValue={filterForm?.finalStatus}
                        items={hardcodeDropdown?.refundStatus}
                        handleChange={(value) => {
                            filterFormHandler("finalStatus", value);
                        }}
                        selectAllMenuButton={true}
                        isShowCount={true}
                        isMulti={true}
                    />

                    <AAutoComplete
                        label="Refund Type"
                        currentValue={filterForm?.refundTypes}
                        items={[...hardcodeDropdown?.subType, INTERNAL_REFUND]}
                        handleChange={(value) => {
                            filterFormHandler("refundTypes", value);
                        }}
                        selectAllMenuButton={true}
                        isShowCount={true}
                        isMulti={true}
                    />

                    {/* <AAutoComplete
                        label="Paymode Type"
                        currentValue={filterForm?.paymentMode}
                        items={paymentMode}
                        handleChange={(value) => {
                            filterFormHandler("paymentMode", value);
                        }}
                        selectAllMenuButton={true}
                        isShowCount={true}
                        isMulti={true}
                    /> */}
                    <div style={labelStyles}>Refund Raised</div>
                    <div className={"d-flex flex justify-content-between"} style={{ columnGap: '10px' }}>
                        <CustomDatePickerV2
                            placeHolder="From"
                            maxDate={moment(new Date())}
                            value={filterForm?.refundRequestDateFrom}
                            width={"18px"}
                            handler={(index, date, keyName) => {
                                filterFormHandler("refundRequestDateFrom", moment(date).startOf('day'));
                                filterFormHandler("refundRequestDateTo", moment(new Date()).endOf('day'));
                            }}
                        />
                        <CustomDatePickerV2
                            placeHolder="To"
                            width={"18px"}
                            maxDate={moment(new Date())}
                            value={filterForm?.refundRequestDateTo}
                            handler={(index, date, keyName) => {
                                filterFormHandler("refundRequestDateTo", moment(date).endOf('day'));
                            }}
                        />
                    </div>
                </div>
                <div className="mt-3 d-flex flex-row-reverse justify-content-between">
                    <AButton
                        variant="primary_filled"
                        className="button_remove_left_margin"
                        onClick={() => {
                            handleApplyFilter();
                        }}
                        disabled={getFilterCount({ ...filterForm }) == 0}
                    >
                        Apply filter
                    </AButton>

                    {filterCount > 0 && (
                        <AButton
                            variant="outline"
                            className="button_remove_left_margin"
                            updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                            onClick={resetFilterForm}
                        >
                            Remove filter
                        </AButton>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default FilterForm;